import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PublishingDepComponent } from './publishing-dep.component';


const routes: Routes = [
  {
    path: '',
    component: PublishingDepComponent,
    data: {
      title: "Ariza holati",
      breadcrumb: "Ariza holati"
    }
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PublishingDepRoutingModule { }
